// src/context/SocketProvider.tsx
import React, { createContext, useContext, useEffect, useState } from "react";
import { io, Socket } from "socket.io-client";

//const SOCKET_URL = "http://172.16.20.112:3000";
const SOCKET_URL = "https://rek-hybrid.co.kr"; // socket.io 서버

const SocketContext = createContext<Socket | null>(null);

export const useSocket = () => useContext(SocketContext);

export const SocketProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [socket, setSocket] = useState<Socket | null>(null);

  // 1. 초기 소켓 연결 및 관리
  useEffect(() => {
    const s = io(SOCKET_URL, {
      transports: ["websocket"],
      // 자동 재연결 설정: 연결이 끊어져도 클라이언트가 계속 시도하도록 기본 설정
      reconnection: true, 
      reconnectionAttempts: Infinity, // 무제한 재연결 시도
      reconnectionDelay: 1000,        // 재연결 시도 간격 (ms)      
    });
    setSocket(s);

    s.on("connect", () => console.log("✅ socket connected", s.id));
    s.on("disconnect", () => console.log("❌ socket disconnected"));
    s.on("reconnect_attempt", () => console.log("⏳ 재연결 시도 중..."));

    return () => {
      s.disconnect();
    };
  }, []);

  // 2. 사용자 활동 감지 및 강제 재연결 로직 추가
  // socket 인스턴스가 생성된 이후에만 리스너를 붙입니다.
  useEffect(() => {
    if (!socket) return; // socket 인스턴스가 아직 null이면 리스너 등록 안 함

    // 사용자 활동(클릭) 시 소켓 상태 확인 및 재연결 함수
    const handleUserActivity = () => {
      // Socket.IO는 `readyState` 대신 `connected` 속성을 사용합니다.
      // 연결이 끊어진(false) 상태이고, 현재 재연결 시도 중이 아니라면 연결을 시작합니다.
      // Socket.IO의 connect()는 끊어진 소켓을 재연결합니다.
      if (socket.disconnected) {
        //console.log('👀 사용자 활동 감지: 연결 끊김 상태. 강제 재연결 시도...');
        socket.connect();
      }
    };

    // 문서 전체에 클릭 이벤트를 등록합니다. (캡처 단계에서 감지)
    document.addEventListener('click', handleUserActivity);

    // 컴포넌트 언마운트 시 또는 socket 객체가 변경될 때 이벤트 리스너 해제
    return () => {
      document.removeEventListener('click', handleUserActivity);
    };
  }, [socket]); // socket 객체가 생성될 때만 실행되도록 의존성 배열에 추가

  return <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>;
};
